import React from 'react'
import { useNavigate } from 'react-router-dom'
import css from './PrivacyFirst.module.css'
import Privacy1 from '../../images/privacy1.png'
import Privacy2 from '../../images/privacy2.png'
import Privacy3 from '../../images/privacy3.png'
import Privacy4 from '../../images/privacy4.png'

const PrivacyFirst = () => {
    const navigate = useNavigate()

    return (
        <section className={css.aboutSection}>
            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Informacje ogólne </h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                           1. Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem url: https://psycholog-dawid-lewko.pl/ <br /> www.psycholog-dawid-lewko.pl <br /><br />
                           2. Operatorem serwisu oraz Administratorem danych osobowych jest: DAWID LEWKO,Zielona Góra
                            ul Bohaterów Westerplatte11
                            pokój 302 III PIĘTRO
                            65-034, Polska<br /><br />
                            3. Adres kontaktowy poczty elektronicznej operatora: psycholog.lewkodawid@interia.pl<br /><br />
                            4. Operator jest Administratorem Twoich danych osobowych w odniesieniu do danych podanych dobrowolnie w Serwisie.<br /><br />

                            <br />
                        </p>
                        <div className={css.textImgContainer}>
                            <p className={css.aboutText}>
                                5. Serwis wykorzystuje dane osobowe w następujących celach:<br /><br />
                                Prowadzenie rozmów typu chat online;<br />
                                Obsługa zapytań przez formularz;<br />
                                Realizacja zamówionych usług;<br />
                                Prezentacja oferty lub informacji. <br /><br/>
                               6. Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich zachowaniu w następujący sposób:
                                Poprzez dobrowolnie wprowadzone w formularzach dane, które zostają wprowadzone do systemów Operatora.
                                Poprzez zapisywanie w urządzeniach końcowych plików cookie (tzw. „ciasteczka”).
                            </p>
                            <img className={css.aboutImg} src={Privacy1} alt="Privacy1" />
                        </div>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Wybrane metody ochrony danych stosowane przez Operatora </h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                            1. Miejsca logowania i wprowadzania danych osobowych są chronione w warstwie transmisji (certyfikat SSL). Dzięki temu dane osobowe i dane logowania, wprowadzone na stronie, zostają zaszyfrowane w komputerze użytkownika i mogą być odczytane jedynie na docelowym serwerze.<br/><br/>
                            2. Operator okresowo zmienia swoje hasła administracyjne.<br/><br/>
                            3. W celu ochrony danych Operator regularnie wykonuje kopie bezpieczeństwa.<br/><br/>
                            4. Istotnym elementem ochrony danych jest regularna aktualizacja wszelkiego oprogramowania, wykorzystywanego przez Operatora do przetwarzania danych osobowych, co w szczególności oznacza regularne aktualizacje komponentów programistycznych.
                            <br />
                        </p>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Hosting</h2>
                    </div>
                    <div className={css.textImgContainer}>
                        <p className={css.aboutText}>
                            1. Serwis jest hostowany (technicznie utrzymywany) na serwerach operatora: Contabo GmbH Aschauer Straße 32a
                        </p>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Twoje prawa i dodatkowe informacje o sposobie wykorzystania danych </h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                            1. W niektórych sytuacjach Administrator ma prawo przekazywać Twoje dane osobowe innym odbiorcom, jeśli będzie to niezbędne do wykonania zawartej z Tobą umowy lub do zrealizowania obowiązków ciążących na Administratorze. Dotyczy to takich grup odbiorców:
                            firma hostingowa na zasadzie powierzenia;<br /><br />
                            upoważnieni pracownicy i współpracownicy, którzy korzystają z danych w celu realizacji celu działania strony;
                            firmy, świadczące usługi marketingu na rzecz Administratora.<br /><br />
                            2. Twoje dane osobowe przetwarzane przez Administratora nie dłużej, niż jest to konieczne do wykonania związanych z nimi czynności określonych osobnymi przepisami (np. o prowadzeniu rachunkowości). W odniesieniu do danych marketingowych dane nie będą przetwarzane dłużej niż przez 3 lata.<br /><br />
                           </p>
                        <div className={css.textImgContainer}>
                            <p className={css.aboutText}>
                                3. Przysługuje Ci prawo żądania od Administratora:<br />
                                dostępu do danych osobowych Ciebie dotyczących,<br />
                                ich sprostowania,<br />
                                usunięcia,<br />
                                ograniczenia przetwarzania,<br />
                                oraz przenoszenia danych.<br /><br />
                                4. Przysługuje Ci prawo do złożenia sprzeciwu w zakresie przetwarzania wskazanego w pkt 3, wobec przetwarzania danych osobowych w celu wykonania prawnie uzasadnionych interesów realizowanych przez Administratora, w tym profilowania, przy czym prawo sprzeciwu nie będzie mogło być wykonane w przypadku istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Ciebie interesów, praw i wolności, w szczególności ustalenia, dochodzenia lub obrony roszczeń.<br/><br/>
                                5. Na działania Administratora przysługuje skarga do Prezesa Urzędu Ochrony Danych Osobowych.<br /><br />
                                6. Podanie danych osobowych jest dobrowolne, lecz niezbędne do obsługi Serwisu.<br /><br />
                                7. W stosunku do Ciebie mogą być podejmowane czynności polegające na zautomatyzowanym podejmowaniu decyzji, w tym profilowaniu w celu świadczenia usług w ramach zawartej umowy oraz w celu prowadzenia przez Administratora marketingu bezpośredniego.<br /><br />
                                8. Dane osobowe nie są przekazywane od krajów trzecich w rozumieniu przepisów o ochronie danych osobowych. Oznacza to, że nie przesyłamy ich poza teren Unii Europejskiej.
                            </p>
                            <img className={css.aboutImg} src={Privacy2} alt="Privacy2" />
                        </div>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Informacje w formularzach</h2>
                    </div>
                    <div className={css.textImgContainer}>
                        <p className={css.aboutText}>
                            1. Serwis zbiera informacje podane dobrowolnie przez użytkownika, w tym dane osobowe, o ile zostaną one podane.<br/><br/>
                            2. Serwis może zapisać informacje o parametrach połączenia (oznaczenie czasu, adres IP).<br/><br/>
                            3. Serwis, w niektórych wypadkach, może zapisać informację ułatwiającą powiązanie danych w formularzu z adresem e-mail użytkownika wypełniającego formularz. W takim wypadku adres e-mail użytkownika pojawia się wewnątrz adresu url strony zawierającej formularz.<br/><br/>
                            4. Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji konkretnego formularza, np. w celu dokonania procesu obsługi zgłoszenia serwisowego lub kontaktu handlowego, rejestracji usług itp. Każdorazowo kontekst i opis formularza w czytelny sposób informuje, do czego on służy.
                        </p>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Logi Administratora</h2>
                    </div>
                    <div className={css.textImgContainer}>
                        <p className={css.aboutText}>
                            1. Informacje zachowaniu użytkowników w serwisie mogą podlegać logowaniu. Dane te są wykorzystywane w celu administrowania serwisem.
                        </p>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Istotne techniki marketingowe</h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                            1. Operator stosuje analizę statystyczną ruchu na stronie, poprzez Google Analytics (Google Inc. z siedzibą w USA). Operator nie przekazuje do operatora tej usługi danych osobowych, a jedynie zanonimizowane informacje. Usługa bazuje na wykorzystaniu ciasteczek w urządzeniu końcowym użytkownika. W zakresie informacji o preferencjach użytkownika gromadzonych przez sieć reklamową Google użytkownik może przeglądać i edytować informacje wynikające z plików cookies przy pomocy narzędzia: https://www.google.com/ads/preferences/
                        </p>
                        <div className={css.textImgContainer}>
                            <p className={css.aboutText}>
                                2. Operator stosuje techniki remarketingowe, pozwalające na dopasowanie przekazów reklamowych do zachowania użytkownika na stronie, co może dawać złudzenie, że dane osobowe użytkownika są wykorzystywane do jego śledzenia, jednak w praktyce nie dochodzi do przekazania żadnych danych osobowych od Operatora do operatorom reklam. Technologicznym warunkiem takich działań jest włączona obsługa plików cookie.<br /><br />
                                3.Operator stosuje korzysta z piksela Facebooka. Ta technologia powoduje, że serwis Facebook (Facebook Inc. z siedzibą w USA) wie, że dana osoba w nim zarejestrowana korzysta z Serwisu. Bazuje w tym wypadku na danych, wobec których sam jest administratorem, Operator nie przekazuje od siebie żadnych dodatkowych danych osobowych serwisowi Facebook. Usługa bazuje na wykorzystaniu ciasteczek w urządzeniu końcowym użytkownika.
                            </p>
                            <img className={css.aboutImg} src={Privacy3} alt="Privacy3" />
                        </div>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Wybrane metody ochrony danych stosowane przez Operatora </h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                            1. Serwis korzysta z plików cookies.<br/><br/>
                            2. Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w szczególności pliki tekstowe, które przechowywane są w urządzeniu końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony internetowej, z której pochodzą, czas przechowywania ich na urządzeniu końcowym oraz unikalny numer.<br/><br/>
                            3. Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu.<br/><br/>
                            4.Pliki cookies wykorzystywane są w następujących celach:<br/><br/>
                           a. utrzymanie sesji użytkownika Serwisu (po zalogowaniu), dzięki której użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać loginu i hasła;<br/>
                           b. realizacji celów określonych powyżej w części „Istotne techniki marketingowe”;<br/>
                           c. W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies: „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu końcowym Użytkownika do czasu wylogowania, opuszczenia strony internetowej lub wyłączenia oprogramowania (przeglądarki internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu końcowym Użytkownika przez czas określony w parametrach plików cookies lub do czasu ich usunięcia przez Użytkownika.<br/>
                           d. Oprogramowanie do przeglądania stron internetowych (przeglądarka internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą dokonać zmiany ustawień w tym zakresie. Przeglądarka internetowa umożliwia usunięcie plików cookies. Możliwe jest także automatyczne blokowanie plików cookies Szczegółowe informacje na ten temat zawiera pomoc lub dokumentacja przeglądarki internetowej. <br/> <br />
                           5.Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre funkcjonalności dostępne na stronach internetowych Serwisu. <br /><br />
                           6. Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu wykorzystywane mogą być również przez współpracujące z operatorem Serwisu podmioty, w szczególności dotyczy to firm: Google (Google Inc. z siedzibą w USA), Facebook (Facebook Inc. z siedzibą w USA), Twitter (Twitter Inc. z siedzibą w USA).
                        </p>
                    </div>
                </li>
            </ul>

            <ul className={css.ofertaList}>
                <li>
                    <div className={css.aboutTitleWrapper}>
                        <h2 className={css.aboutTitle}>Zarządzanie plikami cookies – jak w praktyce wyrażać i cofać zgodę? </h2>
                    </div>
                    <div className={css.aboutContainer}>
                        <p className={css.aboutText}>
                            1. W celu zarządzania ustawienia cookies wybierz z listy poniżej przeglądarkę internetową, której używasz i postępuj zgodnie z instrukcjami:
                            <br /><br />
                            Edge<br />
                            Internet Explorer<br />
                            Chrome<br />
                            Safari<br />
                            Firefox<br />
                            Opera<br /><br />

                        </p>
                        <div className={css.textImgContainer}>
                            <p className={css.aboutText}>
                                2. Urządzenia mobilne:<br /><br />
                                Android<br />
                                Safari (iOS)<br />
                                Windows Phone<br /><br />
                                3. Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa, utrzymania preferencji użytkownika może utrudnić, a w skrajnych przypadkach może uniemożliwić korzystanie ze stron www.<br /><br/>

                            </p>
                            <img className={css.aboutImg} src={Privacy4} alt="Privacy4" />
                        </div>
                    </div>
                </li>
            </ul>
        </section>
    )
}

export default PrivacyFirst
